module.exports = __webpack_public_path__ + "static/media/mobile_child_usage1.8fbb847f.png";